<template>
  <div class="menue-left-top">
    <img
      class="menue-left-top-logo"
      src="@/assets/menuTopLogo.png"
      alt=""
      srcset=""
    >
    <div class="menue-left-top-search">
      <a-input
        class="font12R"
        v-model="searchMenu"
        placeholder="请输入"
        allow-clear
        @change="onChange"
      >
        <a-icon
          slot="prefix"
          type="search"
          style="font-size: 12px;color: #527ACC;"
        />

      </a-input>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      searchMenu: ''
    }
  },
  methods: {
    onChange () {
      this.$emit('searchChange', this.searchMenu)
    }
  }

}
</script>

<style lang="less" scoped>
.menue-left-top {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 16px;
  padding-bottom: 22px;

  .menue-left-top-logo {
    width: 155px;
    height: 42px;
    margin-bottom: 20px;
    margin-right: 17px;
  }

  .menue-left-top-search {
    display: flex;
    align-items: center;
    width: 100%;
    height: 30px;
    background: #FFFFFF;
    box-shadow: inset 0px 3px 6px 1px rgba(40, 120, 255, 0.06);
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    overflow: hidden;

    /deep/.ant-input {
      padding-top: 0;
      padding-bottom: 0;
      font-size: 12px;
      font-family: '思源-Regular';
      color: #2878FF;
    }

  }

}</style>
